import BaseDto from './BaseDto';

export default class SimulationDto extends BaseDto {
    get schema() { // eslint-disable-line
    return Object.assign(super.schema, {
      typeBaremeAjuste: undefined,
      tauxALaBaisse: undefined,
      tauxALaHausse: undefined,
      bareme: undefined,
      baremeAjuste: undefined,
      montantImpotAjusteParMois: undefined,
      montantImpotParMois: undefined,
      pourLeTaux: undefined,

      revenuContribuable: undefined,
      tauxPrelevementContribuable: undefined,
      montantPrelevementContribuable: undefined,
      revenuConjoint: undefined,
      tauxPrelevementConjoint: undefined,
      montantPrelevementConjoint: undefined,
      totalPrelevementCouple: undefined,

      revenuPourTaux: undefined,
      revenuImpose: undefined,
      taux: undefined,
      montantImpot: undefined,

      bilan: undefined,

      contribuableIsDto: undefined,
      impotSourceDto: undefined,

      tauxBaremeAjuste: undefined,
      impotDuContribuable: undefined,
      impotDuCoupleSelonTauxContribuable: undefined,
      montantImpotMinPourBaremeALaBaisse: undefined,

    });
  }

  buildCustom() {
    super.buildCustom();
    return this;
  }

  static getFactory(jsonData = {}) {
    return new SimulationDto(jsonData);
  }
}
